import store from '../../store/index'

export default {
    open(title, message, confirmMessage, cancelMessage, callbackOK, callbackCancel){
        store.commit('modal', {
            display: true,
            title: title,
            message: message,
            confirmMessage: confirmMessage,
            cancelMessage: cancelMessage,
            callbackOK: callbackOK,
            callbackCancel: callbackCancel
        });
    },
    close(){
        store.commit('modal', {
            display: false,
        });
    }
}